jQuery.noConflict();
jQuery(document).ready(function () {
  jQuery(".quick_btn").on("click", function () {
    var product_title_slug = jQuery(this).data("product-title");
    jQuery(".quickview-modal").show();
    jQuery("body").css("overflow", "hidden");
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "https://dallmannconfections.myshopify.com/products/" + product_title_slug + ".js",
      error: function () {},
      success: function (product) {
        console.log(product);
        var quantity;
        var product_item_html = "";
        var card = jQuery("#single-product");
        card.find(".single-mainproduct").remove();
        jQuery(".prodctDetail-box .load-image").hide();
        product_item_html += '<div class="single-mainproduct">';
        product_item_html += '<div class="row">';
        product_item_html += '<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">' + '<div class="thumbnail_container">';
        product_item_html += '<img src="' + product.featured_image + '">' + '<div id="slider" class="flexslider">' + '<ul class="slides">';
        var imagescount = product.images;
        if (imagescount.length > 0) {
          var i;
          for (i = 0; i < imagescount.length; i++) {
            product_item_html += "<li>" + '<img src="' + product.images[i] + '">' + "</li>";
          }
        }
        product_item_html += "</ul>" + "</div>";
        product_item_html += '<div id="carousel" class="flexslider">' + '<ul class="slides">';
        var imagescount = product.images;
        if (imagescount.length > 0) {
          var i;
          for (i = 0; i < imagescount.length; i++) {
            product_item_html += "<li>" + '<img src="' + product.images[i] + '">' + "</li>";
          }
        }
        product_item_html += "</ul>" + "</div>";
        product_item_html += "</div>" + "</div>";
        product_item_html += '<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">' + '<div class="traditional_box">' + "<h2>" + product.title + "</h2>" + "<h4><label>Availability</label>: ";
        if (product.available == true) {
          product_item_html += "In stock";
        } else {
          product_item_html += "Out of Stock";
        }
        product_item_html += "</h4>";
        product_item_html += "<span>";
        var compare_price = product.compare_at_price / 100;
        compare_price = compare_price.toFixed(2);
        var price = product.price / 100;
        price = price.toFixed(2);
        if (product.compare_at_price) {
          product_item_html += '<del style="margin-right:10px;">$' + compare_price + "</del>";
        }
        product_item_html += "$" + price;
        product_item_html += "</span>";
        var optionscount = product.options;
        console.log(product.options);
        console.log(product.variants);
        if (optionscount.length > 0) {
          var j;
          for (j = 0; j < optionscount.length; j++) {
            if (optionscount[j].name != "Title") {
              product_item_html +=
                '<div class="selector-wrapper js product-form__item">' +
                '<label for="SingleOptionSelector-' +
                [j] +
                '">' +
                optionscount[j].name +
                "</label>" +
                '<select class="single-option-selector single-option-selector--product-template product-form__input" id="SingleOptionSelector-' +
                [j] +
                '" data-index="option' +
                optionscount[j].position +
                '">';
              var optionname = optionscount[j].values;
              var k;
              for (k = 0; k < optionname.length; k++) {
                product_item_html += '<option value="' + optionname[k] + '">' + optionname[k] + "</option>";
              }
              product_item_html += "</select>" + "</div>";
            }
          }
          product_item_html += '<select name="id" id="ProductSelect-product-template" class="product-form__variants no-js" style="display:none;">';
          var variantcount = product.variants;
          var i;
          for (i = 0; i < variantcount.length; i++) {
            product_item_html += '<option value="' + variantcount[i].id + '" data-title="' + variantcount[i].title + '" >' + variantcount[i].title + "</option>";
          }
          product_item_html += "</select>";
        }
        if (product.description) {
          var maxLength = 170;
          var description = product.description;
          if (description.length > maxLength) {
            var newStr = description.substring(0, maxLength);
            var removedStr = description.substring(maxLength, description.length);
            product_item_html += newStr;
          } else {
            product_item_html += product.description;
          }
        }

        
       product_item_html +=
        '<div class="product-form__item product-form__item--submit">' +
        '<button type="button" name="add" class="product-form__cart-submit" data-add-to-cart ';
      
      if (product.available != true) {
        product_item_html += 'disabled aria-disabled="true">';
        product_item_html += "Sold Out";
      } else {
        product_item_html += 'data-variant_id="' + product.variants[0].id + '">';
        product_item_html += "Add to Cart";
      }
      
      product_item_html += "</button>" + "</div>" + "</div>" + "</div>";
      product_item_html += "</div>";
      product_item_html += "</div>";
      
      // Append the generated HTML to the container
      card.append(product_item_html);

        
        jQuery(document).ready(function () {
          $(".single-option-selector").on("change", function () {
            var option1 = $("#SingleOptionSelector-0").val();
            var option2 = $("#SingleOptionSelector-1").val();
            var variantoption = option1 + " / " + option2;
            var variantid = $('#ProductSelect-product-template option[data-title="' + variantoption + '"]').val();
          });
          jQuery("a.cart").on("click", function (e) {
            e.preventDefault();
            var variant_id = $('select[name="id"]').val();
            var quantity = $('.mini-cart .cart-items li[data-variant_id="' + variant_id + '"]')
            .find(".item-qty")
            .text();
            var qty = 1;
            if (quantity != "" || quantity != null) {
              qty = parseInt(quantity) + 1;
            }
            var newupdates = { [variant_id]: qty };
            jQuery.post(
              "/cart/update.js",
              { updates: newupdates },
              function (data) {
                cartupdate(data);
                $(".product-form__cart-submit").append('<div class="success-message">Added Successfully</div>');
                setTimeout(function () {
                  $(".success-message").remove();
                }, 1000);
              },
              "json"
            );
          });
        });
      },
    });
  });
  jQuery(".modal-wrapper").on("click", function () {
    jQuery(".quickview-modal").hide();
    jQuery(".preview-modal").hide();
    jQuery(".inquire-modal").hide();
    jQuery("body").css("overflow", "inherit");
    jQuery(".header_container").css("position", "fixed");
    var card = jQuery("#single-product");
    card.find(".single-mainproduct").remove();
    jQuery(".preview-modal .load-image").show();
    jQuery(".preview-modal #convertimage").hide();
  });
  jQuery(".exitButn").click(function () {
    jQuery(".quickview-modal").hide();
    jQuery(".preview-modal").hide();
    jQuery(".inquire-modal").hide();
    jQuery("body").css("overflow", "inherit");
    jQuery(".header_container").css("position", "fixed");
    var card = jQuery("#single-product");
    card.find(".single-mainproduct").remove();
    jQuery(".preview-modal .load-image").show();
    jQuery(".preview-modal #convertimage").hide();
  });
  jQuery("#btn-Preview-Image").click(function () {
    jQuery(".preview-modal").show();
    jQuery("body").css("overflow", "hidden");
    jQuery(".header_container").css("position", "relative");
    setTimeout(function () {
      jQuery(".preview-modal .load-image").hide();
    }, 2000);
    setTimeout(function () {
      jQuery(".preview-modal #convertimage").show();
    }, 2000);
  });
  if (window.matchMedia("(max-width: 767px)").matches) {
    jQuery('main.main-content').css('margin-top', jQuery('.header_container.site-header').outerHeight());
  }
});
jQuery(document).ready(function () {
  jQuery(".quotes-slider").owlCarousel({
    margin: 20,
    loop: true,
    autoWidth: false,
    navigation: true,
    lazyLoad: true,
    nav: true,
    autoplay: false,
    items: 2,
    responsive: { 320: { items: 1 }, 480: { items: 1 }, 767: { items: 1 }, 1000: { items: 1 } },
  });
});
jQuery(document).ready(function () {
  jQuery(".top-slider").owlCarousel({
    margin: 15,
    loop: true,
    autoWidth: false,
    navigation: true,
    lazyLoad: true,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.96 108.52"><defs><style>.a{fill:none;stroke:#98988b;stroke-width:0.94px;}</style></defs><title>Arrow_left</title><path class="a" d="M324.22,341.52l-36,54,36,54" transform="translate(-287.66 -341.26)"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.96 108.52"><defs><style>.a{fill:none;stroke:#98988b;stroke-width:0.94px;}</style></defs><title>Arrow_right</title><path class="a" d="M288.22,449.52l36-54-36-54" transform="translate(-287.83 -341.26)"/></svg>',
    ],
      autoplay: true,
      items: 3,
      responsive: { 320: { items: 1 }, 480: { items: 1 }, 767: { items: 2 }, 1000: { items: 3 } },
      });
      });
      jQuery(document).ready(function () {
      jQuery(".our-slider").owlCarousel({
      margin: 20,
      loop: true,
      autoWidth: false,
      navigation: true,
      lazyLoad: true,
      nav: true,
      navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.96 108.52"><defs><style>.a{fill:none;stroke:#98988b;stroke-width:0.94px;}</style></defs><title>Arrow_left</title><path class="a" d="M324.22,341.52l-36,54,36,54" transform="translate(-287.66 -341.26)"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.96 108.52"><defs><style>.a{fill:none;stroke:#98988b;stroke-width:0.94px;}</style></defs><title>Arrow_right</title><path class="a" d="M288.22,449.52l36-54-36-54" transform="translate(-287.83 -341.26)"/></svg>',
    ],
    autoplay: true,
    items: 4,
    responsive: { 320: { items: 1 }, 480: { items: 1 }, 767: { items: 2 }, 1000: { items: 3 }, 1241: { items: 4 } },
  });
});
jQuery(document).ready(function () {
  jQuery(".collect-slider").owlCarousel({
    margin: 40,
    loop: true,
    autoWidth: false,
    navigation: true,
    lazyLoad: true,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.96 108.52"><defs><style>.a{fill:none;stroke:#98988b;stroke-width:0.94px;}</style></defs><title>Arrow_left</title><path class="a" d="M324.22,341.52l-36,54,36,54" transform="translate(-287.66 -341.26)"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.96 108.52"><defs><style>.a{fill:none;stroke:#98988b;stroke-width:0.94px;}</style></defs><title>Arrow_right</title><path class="a" d="M288.22,449.52l36-54-36-54" transform="translate(-287.83 -341.26)"/></svg>',
    ],
      autoplay: true,
      items: 5,
      responsive: { 1: { items: 1 }, 480: { items: 2 }, 767: { items: 3 }, 1000: { items: 4 }, 1241: { items: 5 } },
      });
      });
      jQuery(".srch").click(function () {
      jQuery(".src_box").toggleClass("active");
      });
      jQuery(".child-menu li.deactive").click(function () {
      jQuery(".child-menu li.active .grandchild-menu").hide("slow");
      jQuery(".child-menu li.active").addClass("deactive");
      jQuery(".child-menu li.active").removeClass("active");
      jQuery(this).removeClass("deactive");
      jQuery(this).find(".grandchild-menu").toggle("slow");
      jQuery(this).addClass("active");
      });
      jQuery(".child-menu li.active").click(function () {
      jQuery(this).addClass("deactive");
      jQuery(this).removeClass("active");
      jQuery(this).find(".grandchild-menu").Toggle();
      });
      jQuery(".chocolate_slide").click(function () {
      jQuery(".corporate_slide").removeClass("active");
      jQuery(".corporate_container").slideUp("slow");
      jQuery(".sub_menucontainer").slideToggle();
      });
      jQuery(".corporate_slide").click(function () {
      jQuery(".chocolate_slide").removeClass("active");
      jQuery(".sub_menucontainer").slideUp("slow");
      jQuery(".corporate_container").slideToggle();
      });
      jQuery(function () {
      jQuery(".bxslider").bxSlider({ mode: "fade", captions: true, auto: true, autoControls: true, stopAutoOnClick: true, pager: true });
      });
      jQuery(".accord-icon").click(function () {
      jQuery(".sub-list").slideToggle();
      jQuery(this).toggleClass("active");
      });
      jQuery(".title-head span").click(function () {
      jQuery(".categories_mob").toggleClass("active");
      });
      jQuery(".close_bar").click(function () {
      jQuery(".categories_mob").removeClass("active");
      });
      jQuery(".grid_view").click(function () {
      jQuery(".grid_view").addClass("active");
      jQuery(".list_view").removeClass("active");
      jQuery(".product-grid-view").removeClass("use-list-view");
      });
      jQuery(".list_view").click(function () {
      jQuery(".grid_view").removeClass("active");
      jQuery(".list_view").addClass("active");
      jQuery(".product-grid-view").addClass("use-list-view");
      });
      jQuery(window).on("load", function () {
      var current_url = window.location.href;
      current_url = current_url.split("view=");
      if (current_url[1] == "list") {
    jQuery(".product-grid-view").hide();
    jQuery(".product-list-view").show();
    jQuery(".grid_view").removeClass("active");
    jQuery(".list_view").addClass("active");
  } else {
                                        jQuery(".product-list-view").hide();
  jQuery(".product-grid-view").show();
  jQuery(".list_view").removeClass("active");
  jQuery(".grid_view").addClass("active");
}
                       });

function updatecart(cart) {
  jQuery("#CartCount").removeClass("hide");
  var cartBtn = jQuery("#CartCount span");
  var value = cartBtn.text() || "0";
  var newvalue = parseInt(value) + parseInt(1);
  cartBtn.text(value.replace(/[0-9]+/, newvalue));
}
jQuery(window).on("load", function () {
  jQuery("#carousel").flexslider({ animation: "slide", controlNav: false, animationLoop: false, slideshow: false, itemWidth: 120, itemMargin: 10, asNavFor: "#slider" });
  jQuery("#slider").flexslider({ animation: "slide", controlNav: false, animationLoop: false, slideshow: false, sync: "#carousel" });
});
jQuery(".address-country-option").each(function () {
  var formId = jQuery(this).data("form-id");
  var countrySelector = "AddressCountry_" + formId;
  var provinceSelector = "AddressProvince_" + formId;
  var containerSelector = "AddressProvinceContainer_" + formId;
  new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
});
jQuery(".address-new-toggle").click(function () {
  jQuery("#AddressNewForm").toggleClass("hide");
  jQuery(".EditAddress").addClass("hide");
});
jQuery(".address-edit-toggle").click(function () {
  var editformid = jQuery(this).data("form-id");
  jQuery("#EditAddress_" + editformid).toggleClass("hide");
  jQuery("#AddressNewForm").addClass("hide");
});
jQuery(".address-delete").click(function () {
  var target = jQuery(this).data("target");
  var confirmMessage = jQuery(this).data("confirm-message");
  if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
    Shopify.postLink(target, { parameters: { _method: "delete" } });
  }
});
jQuery(window).on("load", function () {
  var current_url = window.location.href;
  current_url = current_url.split("login#");
  if (current_url[1] == "recover") {
    jQuery("#CustomerLoginForm").toggleClass("hide");
    jQuery("#RecoverPasswordForm").toggleClass("hide");
  }
});
jQuery("#RecoverPassword").click(function () {
  jQuery("#CustomerLoginForm").toggleClass("hide");
  jQuery("#RecoverPasswordForm").toggleClass("hide");
});
jQuery("#HideRecoverPasswordLink").click(function () {
  jQuery("#CustomerLoginForm").toggleClass("hide");
  jQuery("#RecoverPasswordForm").toggleClass("hide");
});
jQuery(window).on("load", function () {
  var j;
  var compare_product_list = jQuery.cookie("compare_list");
  if (compare_product_list != "" && compare_product_list != undefined) {
    document.getElementById("compare-product").innerHTML = compare_product_list;
    var compare_product_name = compare_product_list.split(",");
    for (j = 0; j < compare_product_name.length; j++) {
      jQuery(".compare-img a[data-product-handle=" + compare_product_name[j] + "]")
      .parent()
      .removeClass("campare-hide");
      jQuery(".compare-img a[data-product-handle=" + compare_product_name[j] + "]")
      .parent()
      .addClass("campare-active");
    }
  }
});
jQuery(document).ready(function () {
  var productid = [];
  var i;
  var date = new Date();
  var exdays = 20;
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  jQuery(".compare-img a").on("click", function () {
    var compare_product_list = jQuery.cookie("compare_list");
    if (compare_product_list != "" && compare_product_list != undefined) {
      productid = compare_product_list.split(",");
    }
    if (jQuery(this).parent().hasClass("campare-hide")) {
      alert(productid.length);
      if (productid.length < 3) {
        var product_handle = jQuery(this).data("product-handle");
        productid.push(product_handle);
        document.getElementById("compare-product").innerHTML = productid;
        var product_slug_list = jQuery("#compare-product").text();
        jQuery(this).parent().addClass("campare-active");
        jQuery(this).parent().removeClass("campare-hide");
        alert(product_slug_list);
        jQuery.cookie("compare_list", product_slug_list, { expires: date }, "/");
      } else {
        alert("Maximum 3 products can add in compare list");
      }
    } else {
      var product_handle = jQuery(this).data("product-handle");
      if (productid.indexOf(product_handle) !== -1) {
        for (i = 0; i < productid.length; i++) {
          if (productid[i] === product_handle) {
            productid.splice(i, 1);
          }
        }
        document.getElementById("compare-product").innerHTML = productid;
        var product_slug_list = jQuery("#compare-product").text();
        jQuery(this).parent().removeClass("campare-active");
        jQuery(this).parent().addClass("campare-hide");
        jQuery.cookie("compare_list", product_slug_list, { expires: date }, "/");
      }
    }
  });
});
jQuery(window).on("load", function () {
  var i;
  jQuery(".select-chocolate-box ul li input:checked").parent().append('<div class="check"></div>');
  jQuery(".select-gift-wrapper ul li input:checked").parent().append('<div class="check"></div>');
  var boxsize = jQuery(".select-chocolate-box ul li input:checked").val();
  if (boxsize == 25) {
    jQuery(".seleted-chocolate-preview ul li").css({ height: "110px", width: "20%" });
  } else if (boxsize == 16) {
    jQuery(".seleted-chocolate-preview ul li").css({ height: "145px", width: "25%" });
  } else if (boxsize == 9) {
    jQuery(".seleted-chocolate-preview ul li").css({ height: "169px", width: "33.3%" });
  } else if (boxsize == 10) {
    jQuery(".seleted-chocolate-preview ul li").css({ height: "110px", width: "20%" });
  } else {
    jQuery(".seleted-chocolate-preview ul li").css({ height: "110px", width: "20%" });
  }
  for (i = 1; i <= 25; i++) {
    if (i <= boxsize) {
      jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").css("display", "block");
      jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").addClass("active");
    } else {
      jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").css("display", "none");
      jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").removeClass("active");
    }
  }
  var giftval = jQuery(".select-gift-wrapper ul.gift-box-select li input:checked").val();
  jQuery("#gift-wrapper").attr("value", giftval);
  jQuery(".customize-gift-wrapp").append('<img id="myimage" data-src="' + giftval + '" src="https://cdn.shopify.com/s/files/1/0096/0672/5668/files/' + giftval + '.jpg">');
  var colortext = $(".color-select li input:checked").val();
  $(".gift-text").css("color", colortext);
  var current_variant = window.location.href;
  var current_variant = current_variant.split("variant=");
  if (current_variant[0] != "https://dallmannconfections.myshopify.com/products/build-your-own-bar?") {
  } else {
    window.location = "https://dallmannconfections.myshopify.com/products/build-your-own-bar";
  }
});
jQuery(document).ready(function () {
  var i;
  jQuery(".select-chocolate-box ul li input").on("click", function () {
    var newboxsize = jQuery(this).val();
    var varid = jQuery(this).data("varid");
    if (newboxsize == 25) {
      jQuery(".seleted-chocolate-preview ul li").css({ height: "110px", width: "20%" });
    } else if (newboxsize == 16) {
      jQuery(".seleted-chocolate-preview ul li").css({ height: "145px", width: "25%" });
    } else if (newboxsize == 9) {
      jQuery(".seleted-chocolate-preview ul li").css({ height: "169px", width: "33.3%" });
    } else if (newboxsize == 10) {
      jQuery(".seleted-chocolate-preview ul li").css({ height: "110px", width: "20%" });
    } else {
      jQuery(".seleted-chocolate-preview ul li").css({ height: "110px", width: "20%" });
    }
    jQuery(".select-chocolate-box ul li .check").remove();
    jQuery(this).parent().append('<div class="check"></div>');
    jQuery("input.choco-counter").val(0);
    $(".seleted-chocolate-preview").find("label").remove();
    $(".seleted-chocolate-preview").find("img").remove();
    $(".seleted-chocolate-preview").find("input").remove();
    $(".seleted-chocolate-preview").find("li").removeClass("select");
    $(".seleted-chocolate-preview li").find("p").remove();
    for (i = 1; i <= 25; i++) {
      if (i <= newboxsize) {
        jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").css("display", "block");
        jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").addClass("active");
      } else {
        jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").css("display", "none");
        jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").removeClass("active");
      }
    }
    jQuery(".select-chocolate-flavors ul li").removeClass("active");
  });
  jQuery(".select-chocolate-flavors ul li img").on("click", function () {
    var newboxsize = jQuery(".select-chocolate-box ul li input:checked").val();
    var fval = jQuery(this).attr("alt");
    for (i = 1; i <= 26; i++) {
      if (jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").hasClass("active")) {
        jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ") p").remove();
        var selected_fval = jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").text();
        if (selected_fval == "") {
          var count = jQuery("input.choco-counter").val();
          count = parseInt(count) + 1;
          jQuery("input.choco-counter").val(count);
          jQuery(this).parent().addClass("active");
          jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").append(
            '<label data-val="' +
            fval +
            '">' +
            fval +
            '</label><input data-val="' +
            fval +
            '" type="hidden" id="flavor' +
            i +
            '" name="properties[flavor' +
            i +
            ']" value="' +
            fval +
            '" required><img data-src="' +
            fval +
            '" src="https://cdn.shopify.com/s/files/1/0096/0672/5668/files/' +
            fval +
            '.jpg">'
          );
          jQuery(".seleted-chocolate-preview ul li:nth-child(" + i + ")").addClass("select");
          break;
        }
      } else {
        alert("you can select max " + newboxsize + " chocolate flavors in this box");
        break;
      }
    }
  });
  jQuery(".chocolate-shaped ul li input").on("click", function () {
    var chocoshap = jQuery(this).val();
    if ($(".product-form__item label:contains('Chocolate shaped')")) {
      $(".product-form__item label:contains('Chocolate shaped') ~ select.single-option-selector :selected").removeAttr("selected");
      $(".product-form__item label:contains('Chocolate shaped') ~ select.single-option-selector").val(chocoshap).trigger("change");
      $(".product-form__item label:contains('Chocolate shaped') ~ select.single-option-selector option[value='" + chocoshap + "']").attr("selected", "selected");
    }
    var current_variant = window.location.href;
    var current_variant = current_variant.split("?variant=");
    if ($('#carousel .slides li[data-variant="' + current_variant[1] + '"]')) {
      $('#carousel .slides li[data-variant="' + current_variant[1] + '"]').trigger("click");
    }
  });
  jQuery(".chocolate-test ul li input").on("click", function () {
    var chocotest = jQuery(this).val();
    if ($(".product-form__item label:contains('Chocolate taste')")) {
      $(".product-form__item label:contains('Chocolate taste') ~ select.single-option-selector :selected").removeAttr("selected");
      $(".product-form__item label:contains('Chocolate taste') ~ select.single-option-selector").val(chocotest).trigger("change");
      $(".product-form__item label:contains('Chocolate taste') ~ select.single-option-selector option[value='" + chocotest + "']").attr("selected", "selected");
    }
    var current_variant = window.location.href;
    var current_variant = current_variant.split("?variant=");
    if ($('#carousel .slides li[data-variant="' + current_variant[1] + '"]')) {
      $('#carousel .slides li[data-variant="' + current_variant[1] + '"]').trigger("click");
    }
  });
  jQuery(".seleted-chocolate-preview ul li").on("click", function () {
    if (jQuery(this).hasClass("select")) {
      jQuery(this).removeClass("select");
      var flavname = jQuery(this).find("img").data("src");
      jQuery(this).find("img").remove();
      jQuery(this).find("label").remove();
      jQuery(this).find("input").remove();
      var count = jQuery("input.choco-counter").val();
      count = parseInt(count) - 1;
      jQuery("input.choco-counter").val(count);
      if (jQuery(".seleted-chocolate-preview ul li img[data-src=" + flavname + "]").length > 0) {
      } else {
        jQuery(".select-chocolate-flavors ul li img[alt=" + flavname + "]")
        .parent()
        .removeClass("active");
      }
    }
  });
  jQuery(".select-gift-wrapper ul.gift-box-select li input").on("click", function (e) {
    jQuery(".customize-gift-wrapp img").remove();
    var giftval = jQuery(this).val();
    jQuery(".select-gift-wrapper ul.gift-box-select li .check").remove();
    jQuery(this).parent().append('<div class="check"></div>');
    jQuery("#gift-wrapper").attr("value", giftval);
    jQuery(".customize-gift-wrapp").append('<img id="myimage" data-src="' + giftval + '" src="https://cdn.shopify.com/s/files/1/0096/0672/5668/files/' + giftval + '.jpg">');
  });
  var updatedvalue;
  var current_value = jQuery("input.product-gallery").val();
  setInterval(function () {
    updatedvalue = jQuery("input.product-gallery").val();
    if (current_value != updatedvalue) {
      jQuery("#gift-wrapper").attr("value", updatedvalue);
    }
  }, 100);
  jQuery(".prev-step-button").on("click", function () {
    jQuery(".first-step").show();
    jQuery(".second-step").hide();
  });
  jQuery(".next-step-button").on("click", function () {
    jQuery(".seleted-chocolate-preview ul li.active").each(function () {
      if (jQuery(this).html() == "") {
        jQuery(this).html("<p>Please fill this box</p>");
        jQuery(this).children("p").css("color", "red");
      }
    });
    var boxval = jQuery(".select-chocolate-box ul li input:checked").val();
    if (jQuery("input.choco-counter").val() == boxval) {
      jQuery(".first-step").hide();
      jQuery(".second-step").show();
    }
  });
  jQuery(".corporate-gifting .product-form__cart-submit").on("click", function (e) {
    e.preventDefault();
    jQuery(".seleted-chocolate-preview ul li.active").each(function () {
      if (jQuery(this).html() == "") {
        jQuery(this).html("<p>Please fill this box</p>");
        jQuery(this).children("p").css("color", "red");
      }
    });
    var boxval = jQuery(".select-chocolate-box ul li input:checked").val();
    if (jQuery("input.choco-counter").val() == boxval) {
      jQuery(".corporate-gifting form").submit();
    }
  });
  $(".wrapp-text").keyup(function (e) {
    var keytext = $(this).val();
    $(".gift-text").text("");
    $(".gift-text").append(keytext);
  });
  $("ul.tabs").each(function () {
    var active,
        content,
        links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
    .find("a")
    .click(function (e) {
      active.removeClass("active");
      content.hide();
      active = $(this);
      content = $($(this).attr("href"));
      active.addClass("active");
      content.show();
      return false;
    });
  });
  jQuery(window).on("load", function () {
    var img_val = $(".chocolate-shaped li input:checked").data("value");
    $("#slider").append('<img class="shap-addon" src="https://cdn.shopify.com/s/files/1/0096/0672/5668/files/' + img_val + '.png">');
    var img_bgcolorurl = $(".chocolate-test li input:checked").data("colorurl");
    $("#slider").css("background", "url(" + img_bgcolorurl + ") no-repeat center center");
  });
  $(".chocolate-shaped li input").click(function () {
    var img_val = $(this).data("value");
    $("#slider .shap-addon").remove();
    $("#slider").append('<img class="shap-addon" src="https://cdn.shopify.com/s/files/1/0096/0672/5668/files/' + img_val + '.png">');
    var img_bgcolorurl = $(".chocolate-test li input:checked").data("colorurl");
    $("#slider").css("background", "url(" + img_bgcolorurl + ") no-repeat center center");
  });
  $(".chocolate-test li input").click(function () {
    var img_bgcolorurl = $(this).data("colorurl");
    $("#slider").css("background", "url(" + img_bgcolorurl + ") no-repeat center center");
  });
  $(".Choose-addons img").click(function () {
    if ($(this).hasClass("active")) {
      var img_val = $(this).data("alt");
      $('#slider img[data-alt="' + img_val + '"]').remove();
      $(this).removeClass("active");
      $(this).addClass("deactive");
    } else {
      var img_val = $(this).data("alt");
      $("#slider").append('<img data-alt="' + img_val + '" class="addons" src="https://cdn.shopify.com/s/files/1/0096/0672/5668/files/' + img_val + '.png">');
      $(this).removeClass("deactive");
      $(this).addClass("active");
    }
  });
  jQuery(".color-select li input").on("click", function () {
    var colorval = jQuery(this).val();
    jQuery(".color-select li .check").remove();
    jQuery(this).parent().append('<div class="check"></div>');
    $(".gift-text").css("color", colorval);
  });
  jQuery("#add-product-card").on("click", function () {
    jQuery(".product-form__cart-submit").click();
    jQuery(".group-box .wrapp-text").val("");
  });
});
jQuery(document).ready(function ($) {
  $(".show-page select.num").on("change", function () {
    window.location.replace(jQuery(this).val());
  });
});
jQuery(function () {
  if ( $("#font").length ) {
    $("#font")
    .fontselect()
    .change(function () {
      var font = $(this).val().replace(/\+/g, " ");
      font = font.split(":");
      $(".gift-text").css("font-family", font[0]);
    });
    $("#font-alignment").change(function () {
      var align = $(this).val();
      $(".gift-text").css("text-align", align);
    });
    $("#font-position").change(function () {
      var position = $(this).val();
      if (position == "bottom") {
        $(".gift-text").css({ top: "auto", bottom: "0" });
      } else if (position == "top") {
        $(".gift-text").css({ top: "0", bottom: "auto" });
      } else {
        $(".gift-text").css({ top: "45%", bottom: "auto" });
      }
    });
  }
});
jQuery(document).ready(function () {
  $(".src_box").keyup(function () {
    var dInput = $(this).val();
    var i;
    var product_html = "";
    var product_url = "";
    var $product = $("#search-auto-results");
    if (dInput != "") {
      jQuery.getJSON("/search/suggest.json", { s: dInput, resources: { types: ["product"], limit: 4, unavailable_products: "bury" } }).done(function (response) {
        var productSuggestions = response.resources.results.products;
        if (productSuggestions.length > 0) {
          product_html += '<div class="search-results"><ul>';
          for (i = 0; i < productSuggestions.length; i++) {
            var newProductSuggestion = productSuggestions[i];
            if(newProductSuggestion.type == 'Flavors'){
               product_url = 'https://dallmannconfections.com/products/build-box'
            }
            else {
              product_url = newProductSuggestion.url;
            }
            product_html +=
              '<li><a href="' +
              product_url +
              '">' +
              '<div class="product-image"><img src="' +
              newProductSuggestion.image +
              '"></div>' +
              '<div class="product-content">' +
              '<div class="product-title">' +
              newProductSuggestion.title +
              "</div>" +
              '<div class="product-price">' +
              newProductSuggestion.price +
              "</div>" +
              "</div>" +
              "</a></li>";
          }
          product_html += "</ul></div>";
          $product.html(product_html);
        } else {
          product_html += '<div class="search-results"><ul><li>No Search Result Found</li></ul></div>';
          $product.html(product_html);
        }
      });
    } else {
      $("#search-auto-results .search-results").remove();
    }
  });
});
jQuery(document).ready(function () {
  $("li.top-cart").click(function () {
    $("#Aod_open_cart").click();
  });
});
jQuery(window).on("load", function () {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    async: false,
    success: function (data) {
      cartupdate(data);
    },
  });
});
function cartitemremove(varid) {
  var qty = 0;
  var newupdates = { [varid]: qty };
  jQuery.post(
    "/cart/update.js",
    { updates: newupdates },
    function (data) {
      cartupdate(data);
    },
    "json"
  );
}
function cartupdate(product) {
  jQuery("#CartCount").removeClass("hide");
  $cartBtn = $("#CartCount span");
  var value = $cartBtn.text() || "0";
  $cartBtn.text(value.replace(/[0-9]+/, product.item_count));
  var i;
  var minicart_html = "";
  var $cart = $(".mini-cart");
  $(".minicart-wrapper").remove();
  var productitems = product.items;
  var total_price = product.total_price / 100;
  total_price = total_price.toFixed(2);
  if (productitems.length > 0) {
    $(".cart-empty").remove();
    minicart_html += '<div class="minicart-wrapper">';
    minicart_html += '<div class="cart-items">';
    minicart_html += "<ul>";
    for (i = 0; i < productitems.length; i++) {
      var price = productitems[i].price / 100;
      price = price.toFixed(2);
      minicart_html +=
        '<li data-variant_id="' +
        productitems[i].variant_id +
        '">' +
        '<div class="item-image"><a href="' +
        productitems[i].url +
        '"><img src="' +
        productitems[i].image +
        '"></a></div>' +
        '<div class="item-title">' +
        '<h3><a href="' +
        productitems[i].url +
        '">' +
        productitems[i].title +
        "</a></h3>" +
        '<div class="item-details">' +
        '<span class="item-price">$' +
        price +
        "</span>" +
        "x" +
        '<span class="item-qty">' +
        productitems[i].quantity +
        "</span>" +
        "</div>" +
        '<div class="remove-item" onclick="cartitemremove(' +
        productitems[i].variant_id +
        ')">Remove</div>' +
        "</div>" +
        "</li>";
    }
    minicart_html += "</ul></div>";
    minicart_html +=
      '<div class="cart-bottom">' +
      '<div class="cart-total"><label>Total</label><span>$' +
      total_price +
      "</span></div>" +
      '<div class="cart-button"><a href="/cart">View Cart</a><span>or</span><a href="/collections/all">Continue Shopping</a><br></div>' +
      "</div>";
    minicart_html += "</div>";
    $cart.append(minicart_html);
  } else {
    minicart_html += '<div class="cart-items cart-empty"><ul><li>No Item available in the cart</li></ul></div>';
    $cart.append(minicart_html);
  }
  var listheight = $(".minicart-wrapper .cart-items").height();
  if (listheight > 400) {
    $(".minicart-wrapper .cart-items").css("max-height", "400px");
    $(".minicart-wrapper .cart-items").css("overflow-y", "scroll");
  }
}
jQuery(document).ready(function ($) {
  thumbnails = $('img[src*="/products/"]').not(":first");
  if (thumbnails.length) {
    thumbnails.bind("click", function () {
      var arrImage = $(this).attr("src").split("?")[0].split(".");
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, "");
      var strNewImage = arrImage.join(".") + "." + strRemaining + "." + strExtention;
      if (typeof variantImages[strNewImage] !== "undefined") {
        productOptions.forEach(function (value, i) {
          optionValue = variantImages[strNewImage]["option-" + i];
          if (
            optionValue !== null &&
            $(".single-option-selector:eq(" + i + ") option").filter(function () {
              return $(this).text() === optionValue;
            }).length
          ) {
            $(".single-option-selector:eq(" + i + ")")
            .val(optionValue)
            .trigger("change");
          }
        });
      }
    });
  }
});
jQuery(document).ready(function ($) {
  $(".inquire-btn").on("click", function () {
    $(".inquire-modal").show();
    $("body").css("overflow", "hidden");
  });
});
function myFunction() {
  var x = document.getElementById("myLinks");
  if (x.style.display === "block") {
    x.style.display = "none";
  } else {
    x.style.display = "block";
  }
}
jQuery(document).ready(function () {
  jQuery(document).on("click", ".closex", function () {
    jQuery(this).parent().css("display", "none");
  });
});
jQuery(document).ready(function ($) {
  $(".custom-review a").click(function () {
    $("html,body").animate({ scrollTop: $(".details_container").offset().top }, "slow");
  });
});
jQuery(document).ready(function () {
    jQuery('body').on('click', function(e) {
      if(!jQuery(e.target).parent().hasClass('read-more')){
        jQuery('.more-content').hide();
      }
    });
  jQuery(".more").click(function () {
    jQuery(".more-content").toggle();
  });
  jQuery('.page-width.rich-text > .main-sec.f-popup.culinary > .sec-box > .button > a,.main-sec .sec-box .button a ').click(function(event){
    event.preventDefault();
    jQuery('.f-form.culinary').toggleClass('show');
  });
  jQuery('.f-form .close-button span').click(function(){
    jQuery('.f-form.culinary').removeClass('show');
  });
    jQuery('.page-width.rich-text > .main-sec.f-popup.female > .sec-box > .button > a,#female-entrepreneur-scholarship-500-annual-student-scholarship-dallmann .slideshow__text-wrap .slideshow__text-content .slideshow__btn-wrapper a ').click(function(event){
    event.preventDefault();
    jQuery('.f-form.female').toggleClass('show');
  });
  jQuery('.f-form .close-button span').click(function(){
    jQuery('.f-form.female').removeClass('show');
  });
});
(function ($) {
  window.SLIDECART_OPENED = function () {
    $("body").addClass("minicart-open");
  };
  window.SLIDECART_ADD_TO_CART = function ({ id, quantity }) {
    if ( !$('.product-custom-bundle').length ) {
      console.log('SLIDE CART CUSTOM ADD TO CART TRIGGERED (custom.js)');
      var ele = $(".rc-radio__input");
      var check_dropdown_subs = $(".rc-template__legacy-radio > .rc-radio");
      var check_for_subs = false;
      if (check_dropdown_subs.length > 1 ) {
        check_dropdown_subs.each(function (i, val) {
          if ($(this).hasClass("rc-option__subsave") && $(this).hasClass("rc-option--active")) {
            check_for_subs = true;
          }
        });
      }
      else if (check_dropdown_subs.length == 1) {
        check_for_subs = true;
      } else {
        check_for_subs = false;
      }
      if (check_for_subs == true) {
        var data = {
          items: [
            // {
            //   id: 42771566199011,
            //   quantity: 1
            // },
            {
              id: 40994969026741,
              quantity: 1
            }
          ]
        };

        // CartJS.removeItemById(42771566199011);
        CartJS.removeItemById(40994969026741);

        setTimeout(function () {
          CartJS.addItems(
            data.items,
            {
              success: function (data, textStatus, jqXHR) {
                setTimeout(function () {
                  // CartJS.updateItemById(42771566199011, 1);
                  CartJS.updateItemById(40994969026741, 1);
                  window.SLIDECART_UPDATE();
                  // window.location.href = '/cart';
                }, 1500);
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.log("Error: " + errorThrown + "!");
              },
            }
          );
        }, 1000);
      } else {
        // CartJS.removeItemById(42771566199011);
        // setTimeout(function () {
        //   var data = {
        //     items: [
        //       {
        //         id: 42771566199011,
        //         quantity: 1
        //       }
        //     ]
        //   };
        //   CartJS.addItems(
        //     data.items,
        //     {
        //       success: function (data, textStatus, jqXHR) {
        //         setTimeout(function () {
        //           CartJS.updateItemById(42771566199011, 1);
        //           window.SLIDECART_UPDATE();
        //           // window.location.href = '/cart';
        //         }, 1500);
        //       },
        //       error: function (jqXHR, textStatus, errorThrown) {
        //         console.log("Error: " + errorThrown + "!");
        //       },
        //     }
        //   );
        // }, 1000);
      }
      return false;
    }
  };
  window.SLIDECART_CLOSED = function () {
    $("body").removeClass("minicart-open");
  };
  window.SLIDECART_UPDATED = function (cart) {
    var check_for_subscription = false;
    var subscription_qty = 0;
    $.each(cart["items"], function (index, value) {
      if (typeof value["selling_plan_allocation"] === 'undefined') {
      } else {
        check_for_subscription = true;
        subscription_qty = value["quantity"];
        if ( value.product_id == 7938663383267 || value.product_id == 4553630842916 ) {
          var get_discount = ( ( value.selling_plan_allocation.compare_at_price - value.selling_plan_allocation.price ) * 100 ) / value.selling_plan_allocation.compare_at_price;
          $('[data-line-item-key="'+$(this)[0]['key']+'"] .main-bottom .discount-off').remove();
          $('[data-line-item-key="'+$(this)[0]['key']+'"] .main-bottom .price').append('<div class="discount-off">'+Math.round(get_discount)+'% OFF</div>');
        }
      }
    });
    if (subscription_qty == 0) {
      CartJS.removeItemById(40994969026741, {
        success: function (data, textStatus, jqXHR) {
          $(document).on("cart.requestComplete", function (event, cart) {
//             window.location.href = "/cart";
          });
        },
      });
    }
    Shopify.getCart(function (newcart) {
      if (newcart.item_count !== cart.item_count || newcart.total_price !== cart.total_price || newcart.token !== cart.token || newcart.items.length !== cart.items.length) {
        window.SLIDECART_CLOSE();
        window.SLIDECART_UPDATE(newcart);
        window.SLIDECART_OPEN();
      }
    }, cart);
  };
  if (window.matchMedia("(max-width: 767px)").matches) {
    jQuery("#carousel").flexslider({ animation: "slide", controlNav: false, animationLoop: false, slideshow: false, itemWidth: 210, itemMargin: 10, asNavFor: "#slider", minItems: 2, maxItems: 3 });
  }

})(jQuery);